import {isNil} from 'ramda';

import {EntityResourceIds} from '@dms/api/shared';

import {getSafely, Nullish} from 'shared/web';

import {AiComposerSourceContext} from './AiComposerDraft';

const CONTEXT_BY_RESOURCE_ID: Partial<Record<EntityResourceIds, AiComposerSourceContext>> = {
  [EntityResourceIds.customer]: 'CUSTOMER',
  [EntityResourceIds.businessCase]: 'BUSINESS_CASE',
  [EntityResourceIds.interest]: 'INTEREST',
  [EntityResourceIds.vehicle]: 'VEHICLE',
  [EntityResourceIds.serviceCase]: 'SERVICE_CASE',
  [EntityResourceIds.serviceOrder]: 'SERVICE_ORDER',
  [EntityResourceIds.rentalOrder]: 'RENTAL_ORDER',
  [EntityResourceIds.workshopInterest]: 'WORKSHOP_INTEREST',
};

export const getAiComposerContext = (
  resourceId: EntityResourceIds | Nullish
): AiComposerSourceContext | null =>
  isNil(resourceId) ? null : (getSafely(CONTEXT_BY_RESOURCE_ID, resourceId) ?? null);
